module.exports = __webpack_public_path__ + "img/register-v2.3f352822.png";